import { JsonConverter, JsonObject, JsonProperty } from "ta-json";

import { ApiResourceConverter } from "../converters/api-resource-converter";
import { FileVersionConverter } from "../converters/file-version-converter";
import { FileVersion } from "../fileversion";
import { ApiResource } from "./api-resource";

@JsonObject()
export class ApiInfoResource {
    @JsonProperty("file_version")
    @JsonConverter(FileVersionConverter)
    readonly fileVersion: FileVersion;

    @JsonProperty("product_version")
    readonly productVersion: string;

    @JsonProperty("minimum_sdk_version")
    @JsonConverter(FileVersionConverter)
    readonly minimumSdkVersion: FileVersion;

    @JsonProperty("routes")
    @JsonConverter(ApiResourceConverter)
    readonly routes: ApiResource;
}
